import 'react-app-polyfill/ie9';
import 'core-js/stable';
import './index.css';
import React from 'react';
import {render} from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './store';

import App from './App';

import './utils/i18n';

import './fonts/fonts.css';
import * as braze from '@braze/web-sdk';

braze.initialize('54f1809f-6650-40b2-86d1-7b45ad235059', {
    baseUrl: 'sdk.iad-03.braze.com',
    safariWebsitePushId: 'web.br.com.cartoonnetwork.cnapp',
    enableLogging: true,
    manageServiceWorkerExternally: true,
});

render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root'),
);
